import { supabase } from '../supabaseClient'

export async function logAction(userId, action, details = {}) {
  if (!userId) return
  await supabase.from('audit_logs').insert({ user_id: userId, action, details })
}
